if (typeof Plugin_Agendio === 'undefined') {

    var Plugin_Agendio = {

        init: function () {
            var buttonAgendio = $('#button-agendio-send');
            if(buttonAgendio.length) {
                buttonAgendio
                    .off('click.agendio.plugin')
                    .on('click.agendio.plugin', function (e) {
                        e.preventDefault();
                        ExtEsp.vyhledejSubjekt(true);
                    });
            }
        },

        openDocument: function (contract, path) {

            if (false === Plugin_Common.detectIE()) {
                Lemo_Alert.addDanger('Agendio nelze otevřít z Vašeho prohlížeče, použijte Microsoft Internet Explorer', 'agendioOpenDocumentNotIe');
                return;
            }

            if (typeof contract === 'undefined' || typeof path === 'undefined') {
                Lemo_Alert.addDanger('Chyba konfigurace pole odkazu Agendio', 'agendioOpenDocumentFieldConfigError');
                return;
            }

            try {
                var ws = new ActiveXObject("WScript.Shell");
                ws.run('"' + path + '" procname=ExecAppDetailByCisloSml Cislo_smlouvy=' + contract);
            } catch (e) {
                Lemo_Alert.addDanger('Agendio se nepodařílo načíst', 'agendioOpenDocumentError');
            }
        },

        update: function () {

            var url = window.location.protocol + '//' + window.location.host;
            var idSection = $('#idSection').val();
            var idItem = $('#idItem').val();

            url += '/plugin/PluginAgendio/ajaxUpdateDocument';

            if (idSection.length) {
                url += '/' + idSection;
                if (idItem.length) {
                    url += '/' + idItem;
                }
            }

            // memcache hash
            var _ch = $('#_ch');
            if (!_ch.length) {
                return;
            }

            $.ajax({
                type: 'post',
                url: url,
                dataType: "json",
                data: {'_ch': _ch.val()},
                global: true,
                beforeSend: function () {
                    Lemo_Alert.addInfo('Agendio zpracování ...', 'agendioUpdateDocumentBeforeSend');
                },
                complete: function () {
                    Lemo_Alert.closeById('agendioUpdateDocumentBeforeSend');
                },
                success: function (r) {

                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }

                    // nastavení formuláře (vždy bez ohledu na status)
                    if (r.hasOwnProperty('data')) {
                        var data = r.data;

                        if (data.hasOwnProperty('agendiopripad')) {
                            $('#agendiopripad').val(data['agendiopripad']);
                        }

                        if (data.hasOwnProperty('agendiosmlouva')) {
                            $('#agendiosmlouva').val(data['agendiosmlouva']);
                        }

                        if (data.hasOwnProperty('agendioodeslano') && true === data['agendioodeslano']) {
                            $('#agendioodeslano').prop('checked', true).attr('checked', true);
                        }
                    }

                    DynaCore_Item.miniformReload(3, 46);
                    DynaCore_Item.miniformReload(110, 91);
                },
                error: function () {
                    Lemo_Alert.addDanger('Agendio zpracování selhalo ...', 'agendioUpdateDocumentError');
                    DynaCore_Item.miniformReload(3, 46);
                    DynaCore_Item.miniformReload(110, 91);
                }
            });
        }
    }
}

$(document)
    .ready(function () {
        Plugin_Agendio.init();
    });
